import { render, staticRenderFns } from "./ProfileNew.vue?vue&type=template&id=1d02719a&scoped=true&"
import script from "./ProfileNew.vue?vue&type=script&lang=js&"
export * from "./ProfileNew.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNew.vue?vue&type=style&index=0&id=1d02719a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d02719a",
  null
  
)

export default component.exports